

























import { Component, Mixins, Prop, Watch, Model, Emit } from "vue-property-decorator";
import {
  FixedPhraseRootReference,
  FixedPhraseReference,
  IFixedPhraseReferenceTreeNode,
  IFixedPhraseReferenceTreeData
} from "../../../domain/document";
import { DirectoryTreeNodesFactory } from "../../system/utilities/DirectoryTreeNodesFactory";
import { TreeNodeDropType } from "../../../domain/system";
import { Directory } from "../../../domain/drawing";
import { ITreeExpandable, ITreeInformation } from "../../system";
import Enumerable from "linq";

@Component({
})
export default class FixedPhraseTreeSelector extends Mixins() implements ITreeExpandable, ITreeInformation {
  @Model("input")
  value: FixedPhraseReference;

  @Prop()
  rootFixedPhrase: FixedPhraseRootReference;

  @Prop({ default: true })
  isPastable: boolean;

  data(): any {
    return {
      selectedFixedPhrase: null as FixedPhraseReference,
      selectedNode: null as IFixedPhraseReferenceTreeNode,
    };
  }
  selectedFixedPhrase: FixedPhraseReference;
  selectedNode: IFixedPhraseReferenceTreeNode;

  get isLoaded(): boolean {
    return (this.nodes !== null)
        && (this.nodes !== undefined)
        && (0 < this.nodes.length);
  }

  get nodes(): IFixedPhraseReferenceTreeData[] {
    const factory = new DirectoryTreeNodesFactory(this.toFixedPhraseNode);
    return factory.create(this.rootFixedPhrase
      ? this.rootFixedPhrase.folders
      : []);
  }

  get selectedKey(): number {
    return this.selectedNode
      ? this.selectedNode.key
      : null;
  }

  @Watch("selectedFixedPhrase")
  onSelectedFixedPhraseUpdated(newValue: FixedPhraseReference, oldValue: FixedPhraseReference): void {
    this.input(newValue);
  }

  @Emit()
  input(value: FixedPhraseReference): any {}

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  expandTree(): void {
    if (!this.isLoaded) {
      return;
    }
    const node = this.$refs.tree as any; // rootが必要なのでanyに変換
    this.expandNode(node.root);
  }

  private expandNode(node: IFixedPhraseReferenceTreeNode): void {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory) {
        this.expandDirectory(node);
      }
    }
    if (node.childNodes instanceof Array) {
      node.childNodes.forEach((t) => this.expandNode(t));
    }
  }

  private expandRootNode(): void {
    this.$nextTick(() => {
      const node = this.$refs.tree as any; // rootが必要なのでanyに変換
      if (!node) { return; }
      const rootNode = node.root as IFixedPhraseReferenceTreeNode;
      if (rootNode.childNodes instanceof Array) {
        const directories = Enumerable.from(rootNode.childNodes)
            .where(n => n.data instanceof Object 
              && n.data.source instanceof Directory).toArray();
        
        // ルートフォルダが1つしかない場合自動選択
        if (directories.length === 1) {
          const root = Enumerable.from(directories).first();
          this.expandDirectory(root);
        }
      }
    });
  }

  private expandDirectory(node: IFixedPhraseReferenceTreeNode): void {
    node.expanded = true;
    node.data.iconClass = "tree-icon-directory-expand";
  }

  @Watch("nodes")
  onNodeUpdated(newValue: IFixedPhraseReferenceTreeData[], oldValue: IFixedPhraseReferenceTreeData[]): void {
    if (!!newValue) {
      this.expandRootNode();　
    }
  }

  @Watch("rootFixedPhrase")
  onRootFixedPhraseUpdated(): void {
    this.selectedNode = null;
  }

  expandKeys(): number[] {
    if (!this.isLoaded) {
      return;
    }
    const node = this.$refs.tree as any; // rootが必要なのでanyに変換
    return this.expandNodeKeys(node.root);
  }

  private expandNodeKeys(node: IFixedPhraseReferenceTreeNode, keys: number[] = []): number[] {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory && node.expanded) {
        keys.push(node.key);
      }
    }
    if (node.childNodes instanceof Array) {
      node.childNodes.forEach((t) => this.expandNodeKeys(t, keys));
    }
    return keys;
  }

  toFixedPhraseNode(entity: FixedPhraseReference, i: number): IFixedPhraseReferenceTreeData {
    return {
      id: i,
      label: entity.name ? entity.name : entity.text,
      iconClass: "tree-icon-fixed-phrase",
      source: entity,
      children: [],
    };
  }

  toToolTipText(node: IFixedPhraseReferenceTreeNode): string {
    return node.data.source instanceof FixedPhraseReference
      ? node.data.source.text
      : node.data.source instanceof Directory ? node.data.source.name : "";
  }

  updateNodeExpand(nodeObject: IFixedPhraseReferenceTreeData, nodeProperty: IFixedPhraseReferenceTreeNode, nodeSelf: any): void {
    if (nodeProperty.data.source instanceof Directory) {
      // nodeSelfは直前の状態の模様。そのため判定は逆になる
      nodeObject.iconClass = nodeSelf.expanded
        ? "tree-icon-directory"
        : "tree-icon-directory-expand";
    }
  }

  handleNodeClicked(nodeObject: IFixedPhraseReferenceTreeData, nodeProperty: IFixedPhraseReferenceTreeNode, nodeSelf: any): void {
    const source = nodeObject.source;
    if (source instanceof FixedPhraseReference) {
      this.selectedFixedPhrase = source;
    }
    if (source instanceof Directory) {
      this.selectedFixedPhrase = null;
    }
    this.selectedNode = nodeProperty;
  }

  handleNodeDblClicked(event: PointerEvent): void {
    // selectedFixedPhrase更新前に発生する場合があるため遅延で呼び出す
    this.$nextTick(() => {
      if (this.selectedNode.data.source instanceof FixedPhraseReference) {
        this.doubleClicked();
      }
    });
  }

  onNodeDragStart(nodeProperty: IFixedPhraseReferenceTreeNode, event: DragEvent): void {
    const data = nodeProperty.data.source;
    if (data instanceof FixedPhraseReference) {
      this.dragStart(event, data.text);
    }
  }

  onAllowDrag(nodeProperty: IFixedPhraseReferenceTreeNode): boolean {
    const data = nodeProperty.data.source;
    if (data instanceof FixedPhraseReference) {
      return true;
    }
    return false;
  }

  onAllowDrop(draggingNode: IFixedPhraseReferenceTreeNode, dropNode: IFixedPhraseReferenceTreeNode, type: TreeNodeDropType) {
    return false;
  }
}
